import { APP_INITIALIZER, NgModule, isDevMode } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { isPlatformServer } from '@angular/common';
import { inject, InjectionToken, PLATFORM_ID } from '@angular/core';
import { FeatureModule } from './feature/feature.module';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';
import { AppHttpInterceptor } from './shared/utilities/intercept';
import { LandingModule } from './feature/landing/landing.module';
import { PaymentModule } from './feature/payment/payment.module';
import { HeaderComponent, IntroService } from './shared';
import { AdminModule } from './feature/admin/admin.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { UserModule } from './feature/user/user.module';
import { AppComponent } from './app.component';
import { AboutUsComponent } from './pages/about-us/about-us.component';
import { NgOptimizedImage } from '@angular/common';
import { ServiceWorkerModule } from '@angular/service-worker';
import { ContactUsComponent } from './pages/contact-us/contact-us.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    AboutUsComponent,
    ContactUsComponent,
  ],
  imports: [
    // BrowserModule.withServerTransition({ appId: 'serverApp' }),
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FeatureModule,
    LandingModule,
    PaymentModule,
    AdminModule,
    UserModule,
    RouterModule,
    CoreModule,
    SharedModule,

    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],

  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppHttpInterceptor,
      multi: true,
    },
    IntroService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
